import React, { useState } from 'react';
import Input from '../ui/Input';
import Space from '../ui/Space';
import Label from '../ui/Label';

const NoteTagEditor = (props) => {

    const {
        controller = "",
        notesArr = [],
        note = "",
        editProps = () => {},
        callback = () => {}
    } = props;

    const [bracketedText, setBracketedText] = useState(notesArr);

    const buildString = (values) => {
        const parts = note.split(/\[([^\]]+)\]/);

        return parts.map((part, index) => {
            return index % 2 === 1
                ? `[${values[Math.floor(index / 2)]}]`
                : part;
        }).join('');
    };

    const handleChange = (index, value) => {
        const newText = [...bracketedText];
        newText[index] = value;

        setBracketedText(newText);

        editProps("note" + index).onChange(value);

        // Pass the complete updated note back
        callback(buildString(newText));
    };

    return (
        <div>
            <Space>
                <Label width={55}>Existing</Label>

                {bracketedText.map((text, index) => (
                    <div key={index}>
                        <Input
                            {...editProps("note" + index)}
                            maxLength={7}
                            width={80}
                            edit
                            onChange={(e) => handleChange(index, e)}
                            value={text}
                        />
                    </div>
                ))}
            </Space>
        </div>
    );
};

export default NoteTagEditor;